import React, { useEffect, useState } from "react";
import { collegeAtGlanceApi } from "../../config/api";
import { apiClient } from "../../utils/apiClient";
import "./college-at-glance.scss";

const BLANK_FORM = {
  _id: null, Title: "College at a Glance", Subtitle: "", Year_of_Establishment: "",
  Affiliation_University: "", Accreditation: "", Campus_Size: "",
  Number_of_Departments: "", Courses_Offered_UG_PG: "", Number_of_Students: "",
  Number_of_Faculty: "", Facilities_Available: "", Location: "",
};

const CollegeAtGlance = () => {
  const [formData, setFormData] = useState(BLANK_FORM);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient(collegeAtGlanceApi);
      const result = await response.json();
      if (response.ok && result.data) {
        const fetchedData = Array.isArray(result.data) ? result.data[0] : result.data;
        if (fetchedData) {
          setFormData(fetchedData);
        }
      }
    } catch (error) {
      console.error("Error fetching college glance data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const method = formData._id ? "PUT" : "POST";
      const url = formData._id ? `${collegeAtGlanceApi}/${formData._id}` : collegeAtGlanceApi;
      const response = await apiClient(url, {
        method,
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
        fetchData();
      }
    } catch (error) {
      console.error("Error saving college glance data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cag-page">
      <div className="cag-page__header">
        <div><h1>College at a Glance</h1><p>Quick overview of the institution's key metrics, affiliations, and resources for public information.</p></div>
        <button className="save-btn" type="submit" form="cagForm" disabled={loading}>{loading ? "Saving..." : saved ? "✓ Saved" : "Update Glance"}</button>
      </div>

      <form id="cagForm" className="cag-form" onSubmit={handleSubmit}>
        <div className="cag-card">
          <div className="form-section-label">General Overview</div>
          <div className="form-group"><label>Display Title</label><input type="text" name="Title" value={formData.Title} onChange={handleChange} placeholder="e.g. College at a Glance" required /></div>
          <div className="form-group"><label>Introduction / Subtitle</label><textarea name="Subtitle" rows="4" value={formData.Subtitle} onChange={handleChange} placeholder="Brief summary about the institution..." /></div>

          <div className="form-section-label">Institutional Profile</div>
          <div className="form-row">
            <div className="form-group"><label>Year of Establishment</label><input type="text" name="Year_of_Establishment" value={formData.Year_of_Establishment} onChange={handleChange} placeholder="e.g. 1994" /></div>
            <div className="form-group"><label>Affiliating University</label><input type="text" name="Affiliation_University" value={formData.Affiliation_University} onChange={handleChange} placeholder="e.g. Lucknow University" /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Accreditation</label><input type="text" name="Accreditation" value={formData.Accreditation} onChange={handleChange} placeholder="e.g. NAAC 'A' Grade" /></div>
            <div className="form-group"><label>Campus Size</label><input type="text" name="Campus_Size" value={formData.Campus_Size} onChange={handleChange} placeholder="e.g. 10 Acres" /></div>
          </div>

          <div className="form-section-label">Key Statistics</div>
          <div className="form-row four-col">
            <div className="form-group"><label>Departments</label><input type="text" name="Number_of_Departments" value={formData.Number_of_Departments} onChange={handleChange} placeholder="e.g. 12" /></div>
            <div className="form-group"><label>Courses</label><input type="text" name="Courses_Offered_UG_PG" value={formData.Courses_Offered_UG_PG} onChange={handleChange} placeholder="e.g. 25" /></div>
            <div className="form-group"><label>Students</label><input type="text" name="Number_of_Students" value={formData.Number_of_Students} onChange={handleChange} placeholder="e.g. 5000+" /></div>
            <div className="form-group"><label>Faculty</label><input type="text" name="Number_of_Faculty" value={formData.Number_of_Faculty} onChange={handleChange} placeholder="e.g. 150+" /></div>
          </div>

          <div className="form-section-label">Infrastructure & Location</div>
          <div className="form-group"><label>Facilities (Comma separated)</label><textarea name="Facilities_Available" rows="4" value={formData.Facilities_Available} onChange={handleChange} placeholder="e.g. Library, Computer Labs, Auditorium, Gym..." /></div>
          <div className="form-group"><label>Official Location</label><input type="text" name="Location" value={formData.Location} onChange={handleChange} placeholder="e.g. Rajat Group Of College, Lucknow, UP" /></div>
        </div>
      </form>
    </div>
  );
};

export default CollegeAtGlance;